import React from "react";

import { DataAcquisitionTypeAndIcon } from "@src/components/molecules/data-acquisistion-type-and-icon/data-acquisistion-type-and-icon";

export const ourNodeRenderDataAcquisitionTypeWrapper = (child, type) => {
  let dataBitType;

  if (
    "attributes" in child &&
    child.attributes &&
    child.attributes.data_acquisition_type &&
    type === "machine"
  ) {
    dataBitType = child.attributes.data_acquisition_type;
  }

  return (
    dataBitType && <DataAcquisitionTypeAndIcon typeOfDataBit={dataBitType} />
  );
};
